export default "__VITE_ASSET__bc9eb914__"